import { render, staticRenderFns } from "./SalesByJournal.vue?vue&type=template&id=2a55f175&"
import script from "./SalesByJournal.vue?vue&type=script&lang=js&"
export * from "./SalesByJournal.vue?vue&type=script&lang=js&"
import style0 from "./SalesByJournal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports